// extracted by mini-css-extract-plugin
export default {"subtitle":"SubTitle_subtitle__S44V1"};